module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-regular.78270194.woff";